let district = [
    { "x": -1, "y": -1, "type": "right", "opts": "start", "pickup": false },
    { "x": -3, "y": -2, "type": "righttoleft" },
    { "x": -3, "y": -3, "type": "left" },
    { "x": -3, "y": -4, "type": "voidleft" },
    { "x": -3, "y": -5, "type": "voidleft" },
    { "x": -3, "y": -6, "type": "left" },
    { "x": -3, "y": -7, "type": "left" },
    { "x": -3, "y": -8, "type": "lefttop" },
    { "x": -4, "y": -9, "type": "voidbottop" },
    { "x": -5, "y": -10, "type": "top" },
    { "x": -6, "y": -11, "type": "topright" },
    { "x": -15, "y": -15, "type": "plateforme321", "pickup": false },

    /* Fake path */
    { "x": -11, "y": -6, "type": "left", "pickup": false }, 
    // { "x": -11, "y": -18, "type": "leftbottorightbot", "pickup": false },
    // { "x": -13, "y": -4, "type": "right", "pickup": false },
    // { "x": -14, "y": -4, "type": "right", "pickup": false },
    { "x": -12, "y": -18, "type": "lefttoright", "pickup": false },
    { "x": -13, "y": -19, "type": "righttoleft", "pickup": false },
    { "x": -13, "y": -20, "type": "right", "pickup": false },
    { "x": -13, "y": -21, "type": "right", "pickup": false },

    { "x": -11, "y": -16, "type": "right", "pickup": false },
    { "x": -12, "y": -5, "type": "lefttoptorighttop", "pickup": false },
    /* */

    {
        "x": -24,
        "y": -24,
        "type": "haussmanbuilding",
        "move": false,
        "pickup": false
    },
    { "x": -17, "y": -12, "type": "righttoleft" },
    { "x": -17, "y": -13, "type": "left" },
    { "x": -17, "y": -14, "type": "lefttop" },
    { "x": -18, "y": -15, "type": "voidbottop" },
    { "x": -19, "y": -16, "type": "top" },
    { "x": -20, "y": -17, "type": "top" },
    { "x": -21, "y": -18, "type": "topright" },
    { "x": -22, "y": -18, "type": "voidright" },
    { "x": -23, "y": -18, "type": "righttop" },
    { "x": -24, "y": -19, "type": "top" },
    { "x": -25, "y": -20, "type": "top" },
    { "x": -26, "y": -21, "type": "voidbottop" },
    { "x": -27, "y": -22, "type": "top" },
    { "x": -28, "y": -23, "type": "topleft" },
    { "x": -28, "y": -24, "type": "lefttop" },
    { "x": -29, "y": -25, "type": "topleft" },
    { "x": -29, "y": -26, "type": "left" },
    { "x": -29, "y": -27, "type": "left" },
    { "x": -29, "y": -28, "type": "voidleft" },
    { "x": -29, "y": -29, "type": "lefttop" },
    { "x": -30, "y": -30, "type": "topleft" },
    { "x": -30, "y": -31, "type": "lefttop" },
    { "x": -31, "y": -32, "type": "topright", "pickup": false },
    { "x": -32, "y": -32, "type": "right", "opts": "end", "pickup": false }
];

export default district;